import type { SupabaseClient } from '../../lib/supabase';

export interface HuddleLinkRow {
  token_tail: string;
  label: string;
  created_at: string;
  revoked_at: string | null;
  last_seen_at: string | null;
  seen_count: number;
  is_live: boolean;
}

export async function listHuddleLinks(
  client: SupabaseClient,
  sectionId: string,
): Promise<HuddleLinkRow[]> {
  const { data, error } = await client.rpc('list_huddle_links', { p_section_id: sectionId });
  if (error) throw new Error(error.message);
  return data ?? [];
}

export async function getHuddleLink(
  client: SupabaseClient,
  sectionId: string,
): Promise<string | null> {
  const { data, error } = await client.rpc('get_huddle_link', { p_section_id: sectionId });
  if (error) throw new Error(error.message);
  return typeof data === 'string' ? data : null;
}

export async function createHuddleLink(client: SupabaseClient, sectionId: string): Promise<string> {
  const { data, error } = await client.rpc('create_huddle_link', { p_section_id: sectionId });
  if (error || typeof data !== 'string') throw new Error(error?.message ?? 'link_not_created');
  return data;
}

export async function revokeHuddleLink(client: SupabaseClient, sectionId: string): Promise<void> {
  const { error } = await client.rpc('revoke_huddle_link', { p_section_id: sectionId });
  if (error) throw new Error(error.message);
}

export function huddleUsage(row: HuddleLinkRow): string {
  const opened =
    row.seen_count === 0
      ? 'Never opened'
      : `Opened ${row.seen_count} ${row.seen_count === 1 ? 'time' : 'times'}`;
  if (row.last_seen_at === null) return opened;
  return `${opened} · last ${new Date(row.last_seen_at).toLocaleString()}`;
}
